<div class="modal-content">
  <div class="modal-header">
      EDITAR INFORMAÇÕES DO BANNER DA HOME
      <img src="./assets/icon_custom/18-p-fechar-b.svg" class="close-btn" (click)="closeModal()">
  </div>
  <div class="modal-body">
      <app-banners-form class="w-100" [bannerToEdit]="data.bannerToEdit" (bannerEmitter)="editBanner($event)"></app-banners-form>
  </div>
</div>
